// $(document).ready(function(){
//   $(document).on('change', '[data-action="ajax_cities"]', function(){
//       let $province   = $(this);
//       let ajaxUrl     = $province.data('ajax_url');
//       let target      = $province.data('target');
//       let $citySelect = $(target);
//       let token       = $('form input[name="_token"]').val();
//       console.log(target);
//       console.log($province);

//       $.post(ajaxUrl, { province_id: $province.val(), _token: token }, function(data) {
//           $citySelect.html('<option value="" selected></option>');
//           for(let i = 0; i < data.length; i++) {
//               $citySelect.append('<option value="'+ data[i].id +'">'+ data[i].name +'</option>');
//           }
//       });
//   });
// });
